/**
 * Onboarding "quick question" step for the AIEcho signup funnel — asks
 * which tasks the creator would hand off to their AI teammate. Mirrors the
 * `{slug, name}` shape of `AppSellerApplicationPurpose`
 * (see `seller-application.ts`).
 *
 * THREE QUESTIONS ANSWER INTO ONE ENUM. The default funnel asks which tasks the
 * creator would hand off; a Growth Rx arrival is instead asked what is holding
 * their growth back, and the `DontKnow*` / `FollowersNoMoney` members below are
 * that question's answers; a SEA arrival is asked what growing a community
 * means to them, and the `Community*` / `FansFeelCaredFor` / `KnowTrueFans`
 * members are that one's. They share the field because they are the same fact
 * from the consumer's side — what this creator wants ECHO to fix — and a reader
 * that only knows the task members must treat an unknown slug as "some other
 * stated need" rather than as absent.
 */
export enum EchoPreferenceSlug {
  BrandDealsDms = 'brand_deals_dms',
  BrandDealsEmail = 'brand_deals_email',
  RespondToComments = 'respond_to_comments',
  PickFollowersToSellTo = 'pick_followers_to_sell_to',
  ConvertIdeaToPdf = 'convert_idea_to_pdf',
  Create90DayGrowthRxPlan = 'create_90_day_growth_rx_plan',
  /** Growth Rx: "I don't know what to post". */
  DontKnowWhatToPost = 'dont_know_what_to_post',
  /** Growth Rx: "I don't know how to go viral". */
  DontKnowHowToGoViral = 'dont_know_how_to_go_viral',
  /** Growth Rx: "I have followers but I'm not making money". */
  FollowersNoMoney = 'followers_no_money',
  /** SEA: "I want my fans to feel that I actually care". */
  FansFeelCaredFor = 'fans_feel_cared_for',
  /** SEA: "I want to build a real community before I ever ask them to buy". */
  CommunityBeforeSelling = 'community_before_selling',
  /** SEA: "I want to know who my true fans actually are". */
  KnowTrueFans = 'know_true_fans',
}

export interface EchoPreference {
  slug: EchoPreferenceSlug;
  name: string;
}
